import { Component, ComponentFactoryResolver, ViewChild, ViewContainerRef } from '@angular/core';
import * as Chartist from 'chartist';
import { ChartType, ChartEvent } from "ng-chartist";
import { NgxSpinnerService } from 'ngx-spinner';


import {
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexYAxis,
  ApexGrid,
  ApexDataLabels,
  ApexStroke,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexLegend,
  ApexPlotOptions,
  ApexFill,
  ApexMarkers,
  ApexTheme,
  ApexNonAxisChartSeries,
  ApexResponsive
} from "ng-apexcharts";

declare var require: any;

const data: any = require('../../shared/data/chartist.json');
import * as chartsData from '../../shared/data/chartjs';
import { ApiService } from 'app/shared/services/api.service';
import  * as  util  from 'app/shared/util/util';

import { ArgumentOutOfRangeError } from 'rxjs';
import { PopupModalComponent } from 'app/shared/popup-modal/popup-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'environments/environment';
import moment from 'moment';
import { DynamicDetailComponent } from 'app/pages/full-pages/admin/dynamic-detail/dynamic-detail.component';
// import { Agent } from 'http';
export interface DynamicDetailData {
  id: number;
  key: string;
  value: string;
}

export type ChartOptions = {
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  colors: string[],
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis | ApexYAxis[],
  title: ApexTitleSubtitle;
  dataLabels: ApexDataLabels,
  stroke: ApexStroke,
  grid: ApexGrid,
  legend?: ApexLegend,
  tooltip?: ApexTooltip,
  plotOptions?: ApexPlotOptions,
  labels?: string[],
  fill: ApexFill,
  markers?: ApexMarkers,
  theme: ApexTheme,
  responsive: ApexResponsive[]
};


var $info = "#2F8BE6",
  $info_light = "#ACE0FC"
var themeColors = [$info, $info_light];


export interface Chart {
  type: ChartType;
  data: Chartist.IChartistData;
  options?: any;
  responsiveOptions?: any;
  events?: ChartEvent;
}
@Component({
  selector: 'app-dashboard2',
  templateUrl: './dashboard2.component.html',
  styleUrls: ['./dashboard2.component.scss']
})

export class Dashboard2Component {

  columnChartOptions: Partial<ChartOptions>;
  totalDue: any;
  totalPending: any;
  item: [];
  monthlyTransactionData = []
  monthly_transactions = []
  month_names = []

  transactionReports: any;
  dueFeeStudent:any
  pendingFeeStudent :any
  duePaging = {
    totalItems: 2222,
    currentPage: 1,
    pageSize: 5,
    maxSize: 5,
    rotate: true,
    boundaryLinks: true,
    directionLinks: true,
    ellipses: false,
    size: 'sm',
    disabled: false
  }
  inTwoDatesTransactionsPaging = {
    totalItems: 2222,
    currentPage: 1,
    pageSize: 5,
    maxSize: 5,
    rotate: true,
    boundaryLinks: true,
    directionLinks: true,
    ellipses: false,
    size: 'sm',
    disabled: false
  }
  pendingPaging = {
    totalItems: 2222,
    currentPage: 1,
    pageSize: 5,
    maxSize: 5,
    rotate: true,
    boundaryLinks: true,
    directionLinks: true,
    ellipses: false,
    size: 'sm',
    disabled: false
  }
  imageUrl=environment.apiUrls.imageUrl;
  months=util.monthsList()
  yearsList=util.yearsList(10)
  selectedMonth:any=new Date().getMonth()+1;
  selectedYear:any=new Date().getFullYear();
  toDay = new Date();
  transactionToDate = this.toDay.toLocaleDateString('en-GB', {year: 'numeric', month: '2-digit',day: '2-digit'});
  transactionFromDate = new Date(this.toDay.getFullYear(), this.toDay.getMonth() -1, this.toDay.getDate()).toLocaleDateString('en-GB', {year: 'numeric', month: '2-digit',day: '2-digit'});
  inTwodatesTransactionData: any;

  guideline_data:any
  row_data:any
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: false }) dynamicContainer: ViewContainerRef;

  constructor(private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,private resolver: ComponentFactoryResolver) {
      let setting_data = JSON.parse(localStorage.getItem('setting-record'))
      this.guideline_data = setting_data.filter((item) => item.key == 'Fees Report') 
    this.getTotalPendingFees();
    this.calculateTransaction();
    this.getTrainingTransactionReports();
    this.listPendingStudentList(this.pendingPaging.currentPage)
    this.listDueStudentList(this.duePaging.currentPage)
    this.transactionFromDate=moment(this.transactionFromDate, "DD/MM/YYYY").format("YYYY-MM-DD");
    this.transactionToDate=moment(this.transactionToDate, "DD/MM/YYYY").format("YYYY-MM-DD");
    this.inTwoDatesTransactions(this.inTwoDatesTransactionsPaging.currentPage)
    // this.columnChartOptions = {
    //   chart: {
    //     height: 350,
    //     type: 'bar',
    //     toolbar: {
    //       show: false
    //     },
    //     animations: {
    //       enabled: false
    //     }
    //   },
    //   colors: themeColors,
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       endingShape: 'rounded',
    //       columnWidth: '25%',
    //     },
    //   },
    //   grid: {
    //     borderColor: "#BDBDBD44"
    //   },
    //   dataLabels: {
    //     enabled: false
    //   },
    //   stroke: {
    //     show: true,
    //     width: 2,
    //     colors: ['transparent']
    //   },
    //   series: [{
    //     name: 'Net Profit',
    //     data: this.monthly_transactions
    //   // }, {
    //   //   name: 'Revenue',
    //   //   data: [30,60.80,120]
    //   }

    // ],
    //   // series: [{
    //   //     name: 'Net Profit',
    //   //     data:[]
    //   //   }
    //   //   ],
    //   legend: {
    //     show: false
    //   },
    //   xaxis: {
    //     categories: this.month_names,
    //     axisBorder: {
    //       color: "#BDBDBD44"
    //     }
    //   },
    //   tooltip: {
    //     y: {
    //       formatter: function (val) {
    //         return "$" + val + " thousands"
    //       }
    //     }
    //   }
    // }

  }
  getTotalPendingFees() {
    this.apiService.getPaymentDue(1, 10).subscribe((res: any) => {
      this.totalDue = res.data.items.totalDue;
    })
    this.apiService.getPaymentPending('', 1, 10).subscribe((res: any) => {
      this.totalPending = res.data.items.totalPending;
    })

  }
  getTrainingTransactionReports() {
    this.apiService.getTrainingTransactionReports().subscribe((res: any) => {
      if (res.isSuccess) {
        this.transactionReports = res.data;
      }
    })
  }
  listPendingStudentList(page) {
    this.apiService.listPendingAndDueStudentList(`pageNo=${page}&pageSize=${this.pendingPaging.pageSize}&list=pendingFeeStudent`).subscribe((res: any) => {
      if (res.isSuccess) {
        this.pendingFeeStudent =res.items
        this.pendingPaging.totalItems=res.total
      }
    })
  }
  listDueStudentList(page) {
    this.apiService.listPendingAndDueStudentList(`pageNo=${page}&pageSize=${this.duePaging.pageSize}&list=dueFeeStudent`).subscribe((res: any) => {
      if (res.isSuccess) {
        this.dueFeeStudent =res.items
        this.duePaging.totalItems=res.total
      }
    })
  }
  inTwoDatesTransactions(page) {
    this.apiService.listPendingAndDueStudentList(`pageNo=${page}&pageSize=${this.inTwoDatesTransactionsPaging.pageSize}&list=inTwoDates&fromDate=${this.transactionFromDate}&toDate=${this.transactionToDate}`).subscribe((res: any) => {
      if (res.isSuccess) {
        this.inTwodatesTransactionData =res.items
        this.inTwoDatesTransactionsPaging.totalItems=res.total
      }
    })
  }
  calculateTransaction() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getTransactionByMonth(this.selectedMonth,this.selectedYear).subscribe((res: any) => {
      this.monthlyTransactionData = res?.data
      this.spinner.hide();
      this.monthly_transactions=this.monthlyTransactionData.map((item)=>item.MonthReceivedAmount)
      this.month_names=this.monthlyTransactionData.map((item)=>item._id)
      this.columnChartOptions = {
        chart: {
          height: 350,
          type: 'bar',
          toolbar: {
            show: false
          },
          animations: {
            enabled: false
          }
        },
        colors: themeColors,
        plotOptions: {
          bar: {
            horizontal: false,
            endingShape: 'rounded',
            columnWidth: '25%',
          },
        },
        grid: {
          borderColor: "#BDBDBD44"
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        series: [{
          name: 'Total earning',
          data: this.monthly_transactions
          // }, {
          //   name: 'Revenue',
          //   data: [30,60.80,120]
        }

        ],
        // series: [{
        //     name: 'Net Profit',
        //     data:[]
        //   }
        //   ],
        legend: {
          show: false
        },
        xaxis: {
          categories: this.month_names,
          axisBorder: {
            color: "#BDBDBD44"
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "₹" + val 
            }
          }
        }
      }

    })

  }

  // barChart
  public barChartOptions = chartsData.barChartOptions;
  public barChartLabels = chartsData.barChartLabels;
  public barChartType = chartsData.barChartType;
  public barChartLegend = chartsData.barChartLegend;
  public barChartData = chartsData.barChartData;
  public barChartColors = chartsData.barChartColors;

  //Column chart



  // Line chart configuration Starts
  WidgetlineChart: Chart = {
    type: 'Line', data: data['WidgetlineDashboard2Chart'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0,
      },
      axisY: {
        showGrid: false,
        low: 50,
        showLabel: false,
        offset: 0,
      },
      fullWidth: true
    },
  };
  WidgetlineChart1: Chart = {
    type: 'Line', data: data['WidgetlineDashboard2Chart_1'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0,
      },
      axisY: {
        showGrid: false,
        low: 50,
        showLabel: false,
        offset: 0,
      },
      fullWidth: true
    },
  };
  WidgetlineChart2: Chart = {
    type: 'Line', data: data['WidgetlineDashboard2Chart_2'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0,
      },
      axisY: {
        showGrid: false,
        low: 50,
        showLabel: false,
        offset: 0,
      },
      fullWidth: true
    },
  };
  WidgetlineChart3: Chart = {
    type: 'Line', data: data['WidgetlineDashboard2Chart_3'],
    options: {
      axisX: {
        showGrid: false,
        showLabel: false,
        offset: 0,
      },
      axisY: {
        showGrid: false,
        low: 50,
        showLabel: false,
        offset: 0,
      },
      fullWidth: true
    },
  };
  // Line chart configuration Ends

  // Line chart configuration Starts
  WidgetlineChartEarning: Chart = {
    type: 'Line', data: data['WidgetlineChartEarning'],
    options: {
      axisX: {
        showGrid: true,
        showLabel: false,
        offset: 0,
      },
      axisY: {
        showGrid: false,
        low: 40,
        showLabel: false,
        offset: 0,
      },
      lineSmooth: Chartist.Interpolation.cardinal({
        tension: 0
      }),
      fullWidth: true
    },
    events: {
      created(data: any): void {

        var defs = data.svg.elem('defs');
        defs.elem('linearGradient', {
          id: 'widgradient1',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-color': '#226CC5'
        }).parent().elem('stop', {
          offset: 1,
          'stop-color': '#81C8F7'
        });
      },

    },
  };
  // Line chart configuration Ends

  // Donut chart configuration Starts
  DonutChart1: Chart = {
    type: 'Pie',
    data: data['DashboardDonut'],
    options: {
      donut: true,
      donutWidth: 3,
      startAngle: 0,
      chartPadding: 25,
      labelInterpolationFnc: function (value) {
        return '\ue8dd';
      }
    },
    events: {
      draw(data: any): void {
        if (data.type === 'label') {
          if (data.index === 0) {
            data.element.attr({
              dx: data.element.root().width() / 2,
              dy: (data.element.root().height() + (data.element.height() / 4)) / 2,
              class: 'ct-label',
              'font-family': 'feather'
            });
          } else {
            data.element.remove();
          }
        }
      }
    }
  };
  // Donut chart configuration Ends

  // Donut chart configuration Starts
  DonutChart2: Chart = {
    type: 'Pie',
    data: data['DashboardDonut'],
    options: {
      donut: true,
      donutWidth: 3,
      startAngle: 90,
      chartPadding: 25,
      labelInterpolationFnc: function (value) {
        return '\ue8f8';
      }
    },
    events: {
      draw(data: any): void {
        if (data.type === 'label') {
          if (data.index === 0) {
            data.element.attr({
              dx: data.element.root().width() / 2,
              dy: (data.element.root().height() + (data.element.height() / 4)) / 2,
              class: 'ct-label',
              'font-family': 'feather'
            });
          } else {
            data.element.remove();
          }
        }
      }
    }
  };
  // Donut chart configuration Ends

  // Donut chart configuration Starts
  DonutChart3: Chart = {
    type: 'Pie',
    data: data['DashboardDonut'],
    options: {
      donut: true,
      donutWidth: 3,
      startAngle: 270,
      chartPadding: 25,
      labelInterpolationFnc: function (value) {
        return '\ue879';
      }
    },
    events: {
      draw(data: any): void {
        if (data.type === 'label') {
          if (data.index === 0) {
            data.element.attr({
              dx: data.element.root().width() / 2,
              dy: (data.element.root().height() + (data.element.height() / 4)) / 2,
              class: 'ct-label',
              'font-family': 'feather'
            });
          } else {
            data.element.remove();
          }
        }
      }
    }
  };
  // Donut chart configuration Ends

  // Line area chart configuration Starts
  lineAreaChart: Chart = {
    type: 'Line',
    data: data['lineArea3'],
    options: {
      low: 0,
      showArea: true,
      fullWidth: true,
      onlyInteger: true,
      axisY: {
        low: 0,
        scaleMinSpace: 50,
      },
      axisX: {
        showGrid: false
      }
    },
    events: {
      created(data: any): void {
        var defs = data.svg.elem('defs');
        defs.elem('linearGradient', {
          id: 'gradient',
          x1: 0,
          y1: 1,
          x2: 0,
          y2: 0
        }).elem('stop', {
          offset: 0,
          'stop-opacity': '0.2',
          'stop-color': 'rgba(255, 255, 255, 1)'
        }).parent().elem('stop', {
          offset: 1,
          'stop-opacity': '0.2',
          'stop-color': 'rgba(181, 131, 255, 1)'
        });
      },
      draw(data: any): void {

        var circleRadius = 6;
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: circleRadius,
            class: 'ct-point-circle'
          });
          data.element.replace(circle);
        }
      }
    },
  };
  // Line area chart configuration Ends

  // Line chart configuration Starts
  lineChart2: Chart = {
    type: 'Line', data: data['line2'],
    options: {
      axisX: {
        showGrid: false,
      },
      axisY: {
        low: 0,
        scaleMinSpace: 50,
      },
      fullWidth: true,
    },
    responsiveOptions: [
      ['screen and (max-width: 640px) and (min-width: 381px)', {
        axisX: {
          labelInterpolationFnc: function (value, index) {
            return index % 2 === 0 ? value : null;
          }
        }
      }],
      ['screen and (max-width: 380px)', {
        axisX: {
          labelInterpolationFnc: function (value, index) {
            return index % 3 === 0 ? value : null;
          }
        }
      }]
    ],
    events: {
      draw(data: any): void {
        var circleRadius = 6;
        if (data.type === 'point') {
          var circle = new Chartist.Svg('circle', {
            cx: data.x,
            cy: data.y,
            r: circleRadius,
            class: 'ct-point-circle'
          });
          data.element.replace(circle);
        }
        else if (data.type === 'label') {
          // adjust label position for rotation
          const dX = data.width / 2 + (30 - data.width)
          data.element.attr({ x: data.element.attr('x') - dX })
        }
      }
    },

  };
  // Line chart configuration Ends
  onResized(event: any) {
    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };
  inTwoDatesPageChange(page: any) {
    this.inTwoDatesTransactions(page)
  }
  onPageChange(event: any) {
this.listPendingStudentList(event)  }
  onduePageChange(event: any) {
   this.listDueStudentList(event)
  }
    openContent(id:any,transaction_Id:any) {
      let enrol_Id=id
      let transaction_id=transaction_Id
      const modalRef = this.modalService.open(PopupModalComponent);
      modalRef.componentInstance.enrol_Id = enrol_Id;
      modalRef.componentInstance.transaction_id = transaction_id;
      modalRef.result.then((data) => {
        if(data == 'success'){
          this.getTrainingTransactionReports();
          this.listPendingStudentList(this.pendingPaging.currentPage)
          this.listDueStudentList(this.duePaging.currentPage)
        }
      }, (reason) => {
        // on dismiss
   });
  }
  openContentAddFee(id:any) {
    const modalRef = this.modalService.open(PopupModalComponent);
    modalRef.componentInstance.enrollId = id
    modalRef.result.then((data) => {
      this.getTrainingTransactionReports();
      this.listPendingStudentList(this.pendingPaging.currentPage)
      this.listDueStudentList(this.duePaging.currentPage)
      // on close
    }, (reason) => {
      // on dismiss
    });
  
  }
  createDynamicComponent(data:DynamicDetailData) {
    this.row_data =data
    // Create a factory for the dynamic component
    const factory = this.resolver.resolveComponentFactory(DynamicDetailComponent);

    // Create an instance of the dynamic component
    const componentRef = factory.create(this.dynamicContainer.injector);

    // Set the data for the dynamic component
    componentRef.instance.data = data;

    // Insert the dynamic component into the view container
    this.dynamicContainer.insert(componentRef.hostView);
  }
  
}
